export class Future {
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this._resolve = value => {
                this._value = value;
                resolve(value);
            };
            this._reject = reason => {
                this._reason = reason;
                reject(reason);
            };
        });
    }
    resolve(value) {
        this._resolve(value);
    }
    reject(reason) {
        this._reject(reason);
    }
    get value() {
        if (this._value !== undefined) {
            return this._value;
        }
        if (this._reason !== undefined) {
            throw this._reason;
        }
        throw new Error("The future is not yet resolved nor rejected");
    }
    get reason() {
        if (this._reason !== undefined) {
            return this._reason;
        }
        if (this._value !== undefined) {
            throw new Error("The future is resolved with a value");
        }
        throw new Error("The future is not yet resolved nor rejected");
    }
}
//# sourceMappingURL=Future.js.map